import * as Actions from "../actions/_ActionTypes";
import * as Pre from "../actions/_PreActionNames";
import * as SecureStore from "../components_v2/DeviceAsyncStorage";
import * as CONSTS from "../../assets/consts";
import CacheStorage from "../modules/cacheStorage";

const initState = {
  isLoading: true,
  users: [],
  guests: [], // keep for backward compatibility
  newCreatedUser: {},
  forcedLogoutReceived: false,
  logoutMessage: "",
  quickAccess: [],
  removeUserError: "",
  sessions: new Array(),
};

const UserReducer = (state = initState, action) => {
  const _state = { ...state };

  var parsedData = null;
  if (action.payload && action.payload.data) {
    parsedData = JSON.parse(action.payload.data);
  }

  if (action.type == Pre.USER + Actions.LOGOUT) {
    console.log("user force logout received");
    _state.forcedLogoutReceived = true;
    _state.users = [];
    _state.quickAccess = [];
    var cacheStorage = new CacheStorage();
    cacheStorage.QuickAccess.ClearAll();
    if (parsedData && parsedData.message) {
      _state.logoutMessage = parsedData.message;
    }
    SecureStore.deleteItemAsync(CONSTS.ACCESS_TOKEN);
    SecureStore.deleteItemAsync(CONSTS.USER_ID);
    SecureStore.deleteItemAsync(CONSTS.USER_QUICK_ACCESS);
    return _state;
  } else if (action.socket && action.socket.send) {
    if (action.type.indexOf("User") == 0) {
      _state.isLoading = true;
    }
    return _state;
    // leave action to execute by server
  }

  switch (action.type) {
    case Pre.USER + Actions.ALL:
      // expected list of users, users[] are members and guests. all include id, name, phoneNumber and areaAccess[] with areaId, areaName , accessLevel name.
      // console.log('parsed in UserReducer > ALL', parsedData)
      _state.users = [...parsedData.users, ...parsedData.guests];
      _state.isLoading = false;
      break;
    case Pre.USER + Actions.ALL_IN_AREA:
      for (var i in parsedData.users) {
        if (!_state.users.some((a) => a.id == parsedData.users[i].id))
          _state.users.push(parsedData.users[i]);
        else {
          for (let j = 0; j < _state.users.length; j++) {
            if (_state.users[j].id == parsedData.users[i].id) {
              _state.users[j] = parsedData.users[i];
              break;
            }
          }
        }
      }
      break;
    case Pre.USER + Actions.REMOVE:
      if (parsedData) {
        var removed = false;
        for (var i in _state.users) {
          if (_state.users[i].id == parsedData.userId) {
            _state.users.splice(i, 1);
            _state.removeUserError = parsedData.error;
            removed = true;
            break;
          }
        }
        if (removed) {
          console.log(
            "user removed received in UserReducer",
            parsedData.userId
          );
        }
        _state.isLoading = false;
      } else {
        _state.removeUserError = "";
      }
      break;

    case Pre.USER + Actions.UPDATE:
      if (parsedData) {
        var updated = false;
        for (var i in _state.users) {
          if (_state.users[i].id == parsedData.id) {
            _state.users[i].description = parsedData.description;
            // if role changed
            if (_state.users[i].expireDate != parsedData.expireDate) {
              _state.users[i].expireDate = parsedData.expireDate;

              var newRole = parsedData.expireDate ? "guest" : "member";
              _state.users[i].topLevel = newRole;

              if (Array.isArray(_state.users[i].areas)) {
                for (let j = 0; j < _state.users[i].areas.length; j++) {
                  _state.users[i].areas[j].accessLevel = newRole;
                }
              }
            }
            //console.log(`_state.users[i] in user reducer update`, _state.users[i])
            updated = true;
            break;
          }
        }

        if (updated) {
          console.log("user updated received in UserReducer", parsedData.id);
        }
      }
      _state.isLoading = false;
      break;
    case Pre.USER + Actions.UPDATE_EXPIRE:
      if (parsedData) {
        for (var i in _state.users) {
          if (_state.users[i].id == parsedData.userId) {
            _state.users[i].expireDate = parsedData.expireDate;
            break;
          }
        }
      }
      _state.isLoading = false;
      break;
    case Pre.USER + Actions.REGISTER_COMPLETED:
      if (parsedData) {
        _state.newCreatedUser = {
          id: parsedData.id,
          phoneNumber: parsedData.phoneNumber,
          fullName: parsedData.fullName,
          role: parsedData.role,
          reservationError: parsedData.error,
        };
        _state.users.push(parsedData);
      }
      break;
    case Pre.USER + Actions.CLEAR_NEW_USER_CACHE:
      _state.newCreatedUser = {
        id: "",
        phoneNumber: "",
        fullName: "",
        role: "",
      };
      break;

    case Pre.USER + Actions.SET_ACCESS_LIST:
      // if response from server contains accessLevels and valid userMemberId
      if (parsedData.accessLevels && parsedData.userMemberId) {
        let member = null,
          changed = false;
        // find member
        for (var u in _state.users) {
          if (_state.users[u].id == parsedData.userMemberId) {
            member = _state.users[u];
            changed = true;
            break;
          }
        }

        // if user is valid
        if (member) {
          member.topLevel = parsedData.topLevel;
          if (!member.areas || !member.areas.length) {
            member.areas = [];
          }
          for (var ac in parsedData.accessLevels) {
            let access = parsedData.accessLevels[ac];
            let existedRole = null,
              indexOfExistedRole = -1;
            for (var a in member.areas) {
              if (member.areas[a].areaId == access.areaId) {
                existedRole = member.areas[a];
                indexOfExistedRole = a;
                break;
              }
            }

            if (existedRole) {
              if (access.accessLevels == "none") {
                // remove role
                member.areas.splice(indexOfExistedRole, 1);
              } else {
                // update to new value
                existedRole.accessLevel = access.accessLevel;
              }
            } else {
              // insert new value
              member.areas.push({
                accessLevel: access.accessLevel,
                areaId: access.areaId,
                areaName: access.areaName,
              });
            }
          }
        }
      }
      //console.log( 'parsedData in UserReducer USER_SET_ACCESS_LIST' , parsedData);

      break;
    // case Pre.USER + Actions.LOGOUT:

    //   break;

    // DEVICE_SET_DEVICE_QUICK_ACCESS is used for backward compatibility and will be remove in next major version
    case Pre.DEVICE + Actions.SET_DEVICE_QUICK_ACCESS:
    case Pre.USER + Actions.SET_DEVICE_QUICK_ACCESS:
      var newList = [];
      if (Array.isArray(action.payload)) {
        newList = action.payload;
      } else if (Array.isArray(parsedData)) {
        newList = parsedData;
      }

      _state.quickAccess = newList;
      var cacheStorage = new CacheStorage();
      cacheStorage.QuickAccess.SetUserQuickAccess(newList);
      break;

    case Pre.USER + Actions.RESET_LOGOUT:
      _state.forcedLogoutReceived = false;
      _state.logoutMessage = "";
      break;
    // case Pre.APP + Actions.RECONNECT:
    //   console.log("APP_RECONNECT received in UserReducer");
    //   _state.users = [];
    //   break;
    case Actions.CLEAR_CACHE:
    case Actions.LOGOUT:
      // console.log("clear UserReducer due to LOGOUT");
      _state.quickAccess = [];
      _state.users = [];
      break;
    // === user joined ===
    case Actions.USER_JOINED:
      _state.users.push(parsedData);
      break;

    case Pre.USER + Actions.GET_SESSIONS:
      _state.sessions = JSON.parse(action.payload.data);
      break;
  }
  return _state;
};

export default UserReducer;
